import { CollectionIcon, ChatAltIcon } from "@heroicons/react/solid";
import { EncryptStorage } from "encrypt-storage";
import { NAVIGATION } from "Route/ConstantRoute";
const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
const userInfo = encryptStorage.getItem("___info");

const SidebarRoute = [
  {
    name: "Dataset Intents",
    href: NAVIGATION.intent,
    icon: CollectionIcon,
    current: false,
  },
  {
    name: "Playground",
    href: NAVIGATION.playground,
    icon: ChatAltIcon,
    current: false,
  },
];

export { SidebarRoute };
